import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function Cost(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="125"
      style={{ height: 'auto', width: 'auto' }}
      viewBox="0 0 160 125"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_7701_274"
          x1="109.511"
          x2="62.3945"
          y1="6.05403"
          y2="107.491"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F7FE" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_7701_274"
          x1="53"
          x2="109"
          y1="52.3294"
          y2="52.3294"
        >
          <stop stopColor="#E1E9F7" />
          <stop offset="1" stopColor="#CDDAF4" />
        </linearGradient>
      </defs>
      <path
        d="M130.076 15.5987C100.085 0.265018 91.1004 28.8401 55.2396 6.90315C23.2379 -12.6689 8.6397 14.6476 4.52417 23.9011C-0.551442 35.3039 -8.03195 63.9899 24.6265 75.0946C66.4573 89.3156 64.2244 112.641 96.4794 122.579C122.342 130.546 146.103 119.114 157.221 84.3608C165.599 58.1728 154.6 28.1395 130.076 15.5987Z"
        fill="url(#paint0_linear_7701_274)"
      />
      <path
        d="M56.4153 54.2471C55.1558 55.5085 53 54.6165 53 52.834V49.9155C53 49.3868 53.2093 48.8796 53.5822 48.5049L73.5232 28.4628C74.307 27.6751 75.5826 27.6773 76.3637 28.4677L85.6289 37.8446C86.4128 38.6379 87.6942 38.6368 88.4767 37.8421L105.575 20.4783C106.83 19.2034 109 20.0923 109 21.8815V24.8349C109 25.36 108.793 25.8641 108.425 26.2382L88.4767 46.4965C87.6942 47.2912 86.4128 47.2923 85.6289 46.4989L76.3612 37.1196C75.5811 36.3301 74.3074 36.3268 73.5232 37.1122L56.4153 54.2471ZM105.173 75.8824C104.068 75.8824 103.173 74.9869 103.173 73.8824V44.244C103.173 43.7177 103.38 43.2126 103.75 42.8383L105.577 40.9892C106.834 39.7177 109 40.6074 109 42.395V73.8824C109 74.9869 108.105 75.8824 107 75.8824H105.173ZM67.5622 89.4706C66.4576 89.4706 65.5622 88.5752 65.5622 87.4706V56.5745C65.5622 56.0482 65.7696 55.5432 66.1395 55.1688L67.9665 53.3198C69.223 52.0482 71.3892 52.9379 71.3892 54.7255V87.4706C71.3892 88.5752 70.4938 89.4706 69.3892 89.4706H67.5622ZM80.1243 84.9412C79.0198 84.9412 78.1243 84.0457 78.1243 82.9412V54.7705C78.1243 52.9767 80.3035 52.0899 81.556 53.374L83.383 55.2471C83.7474 55.6206 83.9513 56.1218 83.9513 56.6436V82.9412C83.9513 84.0457 83.0559 84.9412 81.9513 84.9412H80.1243ZM92.6108 80.4118C91.5062 80.4118 90.6108 79.5163 90.6108 78.4118V56.5821C90.6108 56.0513 90.8218 55.5423 91.1973 55.1672L93.1 53.2663C94.3602 52.0072 96.5135 52.8998 96.5135 54.6811V78.4118C96.5135 79.5163 95.6181 80.4118 94.5135 80.4118H92.6108ZM55 94C53.8954 94 53 93.1046 53 92V68.9126C53 68.3818 53.211 67.8729 53.5864 67.4977L55.4891 65.5968C56.7493 64.3378 58.9027 65.2303 58.9027 67.0117V92C58.9027 93.1046 58.0073 94 56.9027 94H55Z"
        fill="url(#paint1_linear_7701_274)"
      />
    </SvgIcon>
  )
}

export default Cost
